import { styled } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledPreviewAudio = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledAudioPlayer = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 1;
  border-radius: 16px;
  padding: 12px 16px;
  border-width: 1px;
  background-color: ${COLOR.white};
  border: 1px solid ${COLOR.lightDivider};
  width: 592px;
  max-width: 592px;
`;

const StyledAudioInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export { StyledPreviewAudio, StyledAudioPlayer, StyledAudioInfo };
